<template>
  <div v-if="shouldShowLinks" id="lander_links">
    <h3>Links</h3>
    <ul class="org-links">
      <li v-for="link in links" :key="link.id">
        <a :href="link.url" target="_blank">{{ link.title }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  config: {
    type: Object,
    required: false,
    default: () => ({}),
  },
});

const links = computed(() => {
  return props.config?.links || [];
});

const shouldShowLinks = computed(() => {
  // Show if we have any links
  return links.value.length > 0;
});
</script>

<style lang="less">
#lander_links {
  margin-bottom: 2rem;

  li {
    list-style: none;
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
